/** Données mock du PDF « Deliberation Licence1_BD_jan25 - S1 - premiere » */

function mk(
  matricule: string,
  nom: string,
  prenom: string,
  naissance: string,
  uePairs: [string, string][],
  credits: number | string,
  moy: string,
  appr: string,
) {
  return {
    matricule,
    nom,
    prenom,
    naissance,
    ues: uePairs.map(([moyenne, validation]) => ({ moyenne, validation })),
    totalCredits: credits,
    moyenneGenerale: moy,
    appreciation: appr,
  }
}

export const defaultUeColumns = [
  { code: 'UE1', label: 'UE1' },
  { code: 'UE2', label: 'UE2' },
  { code: 'UE3', label: 'UE3' },
  { code: 'UE4', label: 'UE4' },
]

export const defaultHeader = {
  title: 'Tableau de délibération de la classe de Licence 1 informatique Big Data',
  subtitle: 'Année 2024/25 - Semestre 1 - Première session',
}

export const defaultUeBlocks = [
  { title: 'UE1 : Langues 1 [5 crédits]', ecs: [
    { nom: 'Anglais 1', coeff: 1, moy: '11.39' },
    { nom: "Technique d'Expression et de Com 1", coeff: 1, moy: '13.48' },
  ]},
  { title: 'UE2 : OS & Web [6 crédits]', ecs: [
    { nom: 'Système Unix et installation Linux...', coeff: 2, moy: '17.24' },
    { nom: 'Bases du Web', coeff: 2, moy: '12.92' },
  ]},
  { title: 'UE3 : Programmation 1 [11 crédits]', ecs: [
    { nom: 'Langage Python 1', coeff: 2, moy: '15.08' },
    { nom: 'Langage R 1', coeff: 2, moy: '11.65' },
    { nom: 'Algorithmique', coeff: 1, moy: '9.72' },
  ]},
  { title: 'UE4 : Bases de données 1 [8 crédits]', ecs: [
    { nom: 'SIBD 1 (Modélisation et Conception...', coeff: 2, moy: '10.52' },
    { nom: 'SIBD 2 (SQL)', coeff: 2, moy: '11.68' },
  ]},
]

export const defaultStudents = [
  mk('NE2412012','CAMARA','Fatoumata Yarie','17/8/04 à Matoto',[['14.60','Validé'],['17.58','Validé'],['15.44','Validé'],['12.20','Validé']],'30','14.95','Bien'),
  mk('NE2501066','CISSOKHO','Khadidiatou','02/1/00 à Dakar',[['5.20','Non Validé'],['2.05','Non Validé'],['5.16','Non Validé'],['14.28','Validé']],'8','6.67','Insuffisant'),
  mk('NE2501019','DIA','Malal Tacko','26/10/04 à Guédiawaye',[['12.35','Validé'],['15.20','Validé'],['12.76','Validé'],['5.33','Non Validé']],'22','11.41','Passable'),
  mk('NE2412008','DIAGNE','Aminata','26/4/03 à Thiès',[['11.15','Validé'],['16.63','Validé'],['13.06','Validé'],['13.85','Validé']],'30','13.67','Assez Bien'),
  mk('NE2501002','DIAGNE','Mamadou Lamine','18/1/01 à Kaolack',[['13.95','Validé'],['16.28','Validé'],['13.54','Validé'],['11.18','Validé']],'30','13.74','Assez Bien'),
  mk('NE2501049','DIALLO','Khalifa Ababacar','24/11/04 à Diamaguene',[['14.35','Validé'],['16.40','Validé'],['8.82','Non Validé'],['13.05','Validé']],'19','13.16','Assez Bien'),
  mk('NE2411042','DIAW','Thierno Hady','14/11/98 à Matam',[['14.75','Validé'],['18.13','Validé'],['15.42','Validé'],['14.80','Validé']],'30','15.77','Bien'),
  mk('NE2501007','DIAWARA','Bakary','25/3/01 à Port-Gentil',[['15.20','Validé'],['13.35','Validé'],['15.54','Validé'],['12.65','Validé']],'30','14.19','Bien'),
  mk('NE2501039','DIOUF','Mory Mohamed Al Moustapha','27/6/04 à Montreuil',[['15.50','Validé'],['13.98','Validé'],['12.56','Validé'],['6.00','Non Validé']],'22','12.01','Assez Bien'),
  mk('NE2412001','FALL','Salif','01/11/03 à Dakar',[['12.15','Validé'],['16.20','Validé'],['12.56','Validé'],['8.93','Non Validé']],'22','12.46','Assez Bien'),
  mk('NE2412003','FAYE','Nédéye Diminga','30/3/02 à Ngaparou',[['12.55','Validé'],['16.75','Validé'],['13.50','Validé'],['13.55','Validé']],'30','14.09','Bien'),
  mk('NE2412018','KONARE','Nouhou','12/3/96 à Kaolack',[['10.50','Validé'],['10.63','Validé'],['0.96','Non Validé'],['0.00','Non Validé']],'11','5.52','Insuffisant'),
  mk('NE2501020','LOUBANO-VOUMBI','Jordie','03/11/02 à Pointe-Noire',[['13.30','Validé'],['16.80','Validé'],['14.20','Validé'],['13.45','Validé']],'30','14.44','Bien'),
  mk('NE2308004','MANCABOU','Ben Jean Salvador','21/12/04 à Dakar',[['14.30','Validé'],['12.85','Validé'],['10.89','Validé'],['6.80','Non Validé']],'22','11.21','Passable'),
  mk('NE2412016','MBAYE','Abdourahmane Diarra','07/2/89 à Saint-Louis',[['14.65','Validé'],['17.53','Validé'],['17.04','Validé'],['5.85','Non Validé']],'22','13.77','Assez Bien'),
  mk('NE2412022','MBENANGOYE MABIALA','Michel Valdick Ryghen','23/6/02 à Libreville',[['14.90','Validé'],['14.23','Validé'],['13.16','Validé'],['14.20','Validé']],'30','14.12','Bien'),
  mk('NE2401049','NDIAYE','Mame Seynabou','16/9/03 à Thiès',[['13.15','Validé'],['14.25','Validé'],['12.84','Validé'],['13.70','Validé']],'30','13.49','Assez Bien'),
  mk('NE2411013','NDIAYE','Fatou','23/9/02 à Dakar',[['12.20','Validé'],['15.78','Validé'],['14.88','Validé'],['12.35','Validé']],'30','13.80','Assez Bien'),
  mk('NE2501029','SALL','Fatoumata Binta','02/10/00 à Yeumbeul',[['8.90','Non Validé'],['16.68','Validé'],['12.40','Validé'],['9.20','Non Validé']],'17','11.79','Passable'),
  mk('NE2412028','SECK','Mouhamadou Habib','28/7/03 à Rufisque',[['12.80','Validé'],['17.90','Validé'],['13.52','Validé'],['14.70','Validé']],'30','14.73','Bien'),
  mk('NE2412009','SENE','Mohamed Seydou','12/8/00 à Diohine',[['12.80','Validé'],['18.73','Validé'],['13.88','Validé'],['12.00','Validé']],'30','14.35','Bien'),
  mk('NE2501070','SENE','Badara','27/3/02 à Dakar',[['12.73','Validé'],['15.68','Validé'],['14.04','Validé'],['7.65','Non Validé']],'22','12.52','Assez Bien'),
  mk('NE2501028','SOUANE','Mouhamadou Moustapha','25/6/03 à Dakar',[['14.00','Validé'],['16.83','Validé'],['15.48','Validé'],['14.20','Validé']],'30','15.13','Bien'),
  mk('NE2501027','THIAM','Serigne Saliou Mbacké','23/2/04 à Touba',[['12.88','Validé'],['16.00','Validé'],['12.48','Validé'],['12.85','Validé']],'30','13.55','Assez Bien'),
  mk('NE2401039','TOURE','Almamy','21/6/02 à Conakry',[['2.00','Non Validé'],['10.65','Validé'],['11.76','Validé'],['14.65','Validé']],'25','9.77','Insuffisant'),
]

export const defaultAppreciationStats = [
  { label: 'Médiocre',    nombre: 0,  pourcentage: '0.00%'  },
  { label: 'Insuffisant', nombre: 3,  pourcentage: '12.00%' },
  { label: 'Passable',    nombre: 3,  pourcentage: '12.00%' },
  { label: 'Assez Bien',  nombre: 10, pourcentage: '40.00%' },
  { label: 'Bien',        nombre: 9,  pourcentage: '36.00%' },
  { label: 'Très Bien',   nombre: 0,  pourcentage: '0.00%'  },
  { label: 'Excellent',   nombre: 0,  pourcentage: '0.00%'  },
]

export const defaultUeValidation = [
  { code: 'UE1', valide: 22, nonValide: 3, txReussite: '88.00%' },
  { code: 'UE2', valide: 24, nonValide: 1, txReussite: '96.00%' },
  { code: 'UE3', valide: 22, nonValide: 3, txReussite: '88.00%' },
  { code: 'UE4', valide: 17, nonValide: 8, txReussite: '68.00%' },
]

export const defaultEffectif = { total: 25, reussites: 14, taux: '56.00%' }

export const defaultSignatureDirecteur = {
  line1: 'Directeur des Études :',
  line2: 'Seydou Nourou SYLLA',
}

export const defaultSignatureMembers = [
  { line1: 'Abdou Wahab DIALLO' },
  { line1: 'Abdoulaye Wakhab DIOP', line2: 'Langage R 1' },
  { line1: 'Papa Bouna FALL', line2: 'Anglais 1' },
  { line1: 'M. DIOP', line2: 'SIBD 2 (SQL)' },
  { line1: 'Ibrahima GAYE', line2: 'Algorithmique' },
  { line1: 'Abdoulaye BARRO', line2: 'Langage Python 1' },
  { line1: 'Ousmane NDIAYE', line2: 'Bases du Web' },
  { line1: 'Patrick NGOUNE', line2: 'Système Unix et installation Linux...', line2Italic: true },
]
